import appOptions from './appOptions';
import CONSTANTS from './constants';
import utility from './utility';
import egtnlEvaluator from '../helpers/egtnlWeb';
import config from './config';

/**
 *  Vrbo_Web_Optimize_BwC_Module
 *  https://egtnl.prod.expedia.com/experiment/51100
 *  Returns true if the A/B Optimize BwC test is enabled and is not a native mobile request
 * @returns {boolean}
 */
function isOptimizeBwCModule() {
    return (
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('51100')
    );
}

function isOptimisePaymentProtectionModuleDesktopTablet() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('54843');
}

function isOptimisePaymentProtectionModuleMwebNative() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('54847');
}

/**
 *  Vrbo_CKO_No_Extra_Fees_MultiPay_Extended
 *  https://egtnl.prod.expedia.com/experiment/52050
 *  Returns true if the A/B no extra fees messaging test is enabled and is not a native mobile request
 * @returns {boolean}
 */
function isFeeMessagingMultipayEnabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52050')
    );
}

/**
 *  VRBO_CKO_Desktop_Remove_Bwc_Top
 *  https://egtnl.prod.expedia.com/experiment/51150
 *  Returns true if the Bwc message on top is disabled, and is not a native mobile request
 * @returns {boolean}
 */
function isBwcTopMessageDisabledDesktop() {
    return (
        utility.isNativeMobileRequest() === false &&
        !utility.isMobileViewport() &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('51150')
    );
}

/**
 *  Vrbo_OneKey_Credit_Card
 *  https://egtnl.prod.expedia.com/experiment/51581
 *  Returns true if the A/B premier host message is enabled for all POS
 * @returns {boolean}
 */
function isOneKeyCreditCardEnabled() {
    return (
        egtnlEvaluator.isEgtnlTestEnabledAndLog('51581') &&
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US
    );
}

/**
 *  Vrbo_CKO_Two_Step_Checkout
 *  https://egtnl.prod.expedia.com/experiment/52429
 *  Returns true if the A/B for 2 step checkout is enabled.
 * @returns {boolean}
 */
function isTwoPageCheckoutEnabled() {
    return (
        utility.isOlpCheckout() === false &&
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52429')
    );
}

/**
 *  vrbo_tag_commander_checkout
 *  https://egtnl.prod.expedia.com/experiment/51925
 *  Returns true if the feature gate for integrating tag commander is enabled
 * @returns {boolean}
 */
function isVrboTagCommanderIntegration() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('51925');
}

/**
 *  Vrbo_CKO_Update_One_Key_Icon_Colors
 *  https://egtnl.prod.expedia.com/experiment/51680
 *  Returns true if the feature gate for using the updated OK icon and colors is enabled
 * @returns {boolean}
 */
function updateOneKeyIconColors() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('51680');
}

/**
 *  InsurTech_Vrbo_HygieneFix2
 *  https://egtnl.prod.expedia.com/experiment/52270
 *  Returns true if the A/B for Hygiene fix test is enabled for US POS
 * @returns {boolean}
 */
function isHygieneFixTestEnabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52270')
    );
}

/**
 *  InsurTech_VRBO_TPAssistance
 *  https://egtnl.prod.expedia.com/experiment/52384
 *  Returns true if the A/B for 24/7 assistance on TP module is enabled for US POS
 * @returns {boolean}
 */
function isTPAssistanceEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52384')
    );
}

/**
 *  InsurTech_VRBO_ADPAssistance
 *  https://egtnl.prod.expedia.com/experiment/52383
 *  Returns true if the A/B for 24/7 assistance on ADP module is enabled for US POS
 * @returns {boolean}
 */
function isADPAssistanceEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52383')
    );
}

/**
 *  InsurTech_VRBO_CKOPriming
 *  https://egtnl.prod.expedia.com/experiment/52385
 *  Returns true if the A/B for CKO priming is enabled
 * @returns {boolean}
 */
function isCKOPrimingEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperiment('52429').value === 0 &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('52385')
    );
}

/**
 *  VRBO_CKO_Remove_Covid_Verbiage_InStepTwo
 *  https://egtnl.prod.expedia.com/experiment/52811
 *  Returns true if A/B for CKO covid verbiage removal is enabled
 * @returns {boolean}
 */
function isCovidVerbiageInStepTwoRemoved() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('52811');
}

/**
 *  VRBO_CKO_Tier_Specific_OneKey_Banner
 *  https://egtnl.prod.expedia.com/experiment/54422
 *  Returns true if A/B for Tier Specific OneKey banner is on variant
 * @returns {boolean}
 */
function isTierSpecificOneKeyBanner() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('54422')
    );
}

/**
 *  NATIVE_Vrbex_Reviews_outof10
 *  https://egtnl.prod.expedia.com/experiment/51738
 *  Returns true if the A/B for Property Rating Scale change is enabled
 * @returns {boolean}
 */
function isPropertyRatingChangeEnabled() {
    if (utility.isNativeMobileRequest()) {
        return egtnlEvaluator.isEgtnlTestEnabledAndLog('51738');
    }
    return true;
}

/**
 *  InsurTech_VRBO_ADP_BenefitOptimization
 *  https://egtnl.prod.expedia.com/experiment/53439
 *  returns egtnl experiment object for ADP benefit optimization
 * @returns {object}
 */
function isADPBenefitOptimizationEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperimentAndLog('53439')
    );
}
/**
 *  Vrbo_CKO_Display_Generic_Payment_Error
 *  https://egtnl.prod.expedia.com/experiment/53565
 *  Returns true if the A/B for generic payment error is enabled
 * @returns {boolean}
 */

function displayGenericPaymentError() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('53565');
}

/**
 *  Vrbo_CKO_Web_Payment_Error_Banner_Redesign
 *  https://egtnl.prod.expedia.com/experiment/55967
 *  Returns true if the A/B for payment error banner error is enabled
 * @returns {boolean}
 */
const isPaymentErrorBannerRedesignEnabledWeb = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('55967');

/**
 *  Vrbo_CKO_Native_Payment_Error_Banner_Redesign
 * https://egtnl.prod.expedia.com/experiment/55968
 *  Returns true if the A/B for payment error banner error is enabled
 * @returns {boolean}
 */
const isPaymentErrorBannerRedesignEnabledMobile = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('55968');

/**
 *  NATIVE_Mandatory_Fields_Required_Info
 *  https://egtnl.prod.expedia.com/experiment/53974
 *  Returns true if the A/B for Mandatory Required Fields Info is enabled
 * @returns {boolean}
 */
function isMandatoryRequiredFieldsInfoEnabledMobile() {
    return (
        utility.isNativeMobileRequest() === true &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('53974')
    );
}

/**
 *  VRBO_CKO_Native_Disclosure_Box_Update
 *  https://egtnl.prod.expedia.com/experiment/53616
 *  Returns true if the A/B for currency disclosure box update is enabled
 * @returns {boolean}
 */
function isCurrencyDisclosureBoxUpdatedMobile() {
    return (
        utility.isNativeMobileRequest() === true &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('53616')
    );
}

/**
 *  VRBO_CKO_Web_Disclosure_Box_Update
 *  https://egtnl.prod.expedia.com/experiment/54106
 *  Returns true if the A/B for currency disclosure box update is enabled
 * @returns {boolean}
 */
function isCurrencyDisclosureBoxUpdatedWeb() {
    return (
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('54106')
    );
}

/**
 *  VRBO_CKO_Feedback_for_Text_Fields
 *  https://egtnl.prod.expedia.com/experiment/54145
 *  Returns true if A/B for Feedback for Text Fields is enabled
 * @returns {boolean}
 */
function isFeedbackForTextFields() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('54145');
}

/**
 *  Insurtech_Vrbo_VAS_IPSNIFF (no exposure logging)
 *  https://egtnl.prod.expedia.com/experiment/67994
 *  Returns true if the ipsniff experiment is enabled without logging an exposure.
 *  Use this when another code path already logs the exposure to avoid over-exposure.
 * @returns {boolean}
 */
function isInsurtechVrboVasIpsniffEnabledNoLog() {
    return egtnlEvaluator.evaluateExperiment('67994')?.value === 1;
}

/**
 *  2 Step interstitial on APP
 *  https://egtnl.prod.expedia.com/experiment/54457
 *  Returns true if 2 Step interstitial on APP is enabled.
 *  When ipSniff (experiment 67994) is enabled, resolves the country from
 *  `appOptions.get('geoCountryCode')` (post-init) with a fallback to
 *  `config.geoCountryCode` (available at module load). Otherwise uses POS
 *  `appOptions.get('countryCode')`.
 * @returns {boolean}
 */
function isTwoStepInterstitialTestEnabledMobile() {
    if (utility.isNativeMobileRequest()) {
        const geoCountryCode = isInsurtechVrboVasIpsniffEnabledNoLog()
            ? appOptions.get('geoCountryCode') ?? config.geoCountryCode ?? null
            : null;
        const countryCode = geoCountryCode || appOptions.get('countryCode');
        const supportedCountries = [
            CONSTANTS.COUNTRY_CODES.US,
            CONSTANTS.COUNTRY_CODES.CA,
        ];
        return (
            supportedCountries.includes(countryCode) &&
            egtnlEvaluator.isEgtnlTestEnabledAndLog('54457')
        );
    }
    return false;
}

/**
 *  InsurTech Vrbo Convergence Interstitial TnL
 *  https://egtnl.prod.expedia.com/experiment/62205
 * @returns {boolean}
 */
function isInsurTechVrboConvergenceEnabled(countryCode) {
    const supportedCountries = [
        CONSTANTS.COUNTRY_CODES.US,
        CONSTANTS.COUNTRY_CODES.MX,
    ];
    return (
        supportedCountries.includes(countryCode) &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('62205')
    );
}

/**
 *  InsurTech Vrbo Canada Convergence Interstitial & VasCart
 *  https://egtnl.prod.expedia.com/experiment/64992
 * @returns {boolean}
 */
function isInsurTechVrboCAConvergenceEnabled(countryCode) {
    return (
        countryCode === CONSTANTS.COUNTRY_CODES.CA &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('64992')
    );
}

/**
 *  Insurtech_Vrbo_VAS_IPSNIFF
 *  https://egtnl.prod.expedia.com/experiment/67994
 *  Returns true if the experiment to use cookie-based countryCode for VAS is enabled
 * @returns {boolean}
 */
function isInsurtechVrboVasIpsniffEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('67994');
}

/**
 *  VRBO_CKO_Web_Two_Page_Checkout_Test
 *  https://egtnl.prod.expedia.com/experiment/54144
 *  Returns true if the A/B for 2 step checkout is enabled.
 * @returns {boolean}
 */
function isTwoPageCheckoutDesktopTabletWebV2Enabled() {
    return (
        utility.isNativeMobileRequest() === false &&
        utility.detectEdgeV126() === false &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('54144')
    );
}

/**
 *  VRBO_CKO_Priming_On_2step_CKO
 *  https://egtnl.prod.expedia.com/experiment/58806
 *  Returns true if the A/B for 2 step checkout is enabled.
 * @returns {String}
 */
function isPrimingOnTwoPageCheckout() {
    if (
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.evaluateExperimentAndLog('58806').value === 1
    ) {
        return 'v1';
    } else if (
        utility.isNativeMobileRequest() === false &&
        egtnlEvaluator.evaluateExperimentAndLog('58806').value === 2
    ) {
        return 'v2';
    }
    return '';
}

/**
 *  VRBO_CKO_Native_Two_Page_Checkout_Test
 *  https://egtnl.prod.expedia.com/experiment/54143
 *  Returns true if the A/B for 2 step checkout is enabled.
 * @returns {boolean}
 */
function isTwoPageCheckoutMobileV2Enabled() {
    return (
        utility.isNativeMobileRequest() === true &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('54143')
    );
}

/**
 *  Revisit TP Priming
 *  https://egtnl.prod.expedia.com/experiment/55032
 *  Returns egtnl experiment object if the A/B for Revisit TP Priming is enabled
 * @returns {object}
 */
function isTPPrimingEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperimentAndLog('55032')
    );
}

/**
 *  InsurTech_Vrbo_Update_Colors
 *  https://egtnl.prod.expedia.com/experiment/55188
 *  Returns true if the feature gate for InsurTech_Vrbo_Update_Colors is enabled
 * @returns {boolean}
 */
function updateInsurTechTouchpointsColorsEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('55188')
    );
}

/**
 *  Vrbo_Static_Booking_Nudge
 *  https://egtnl.prod.expedia.com/experiment/55233
 *  Returns true if Static Booking Nudge test is enabled
 * @returns {boolean}
 */
function isVrboStaticBookingNudge() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55233');
}

/**
 *  VRBO_STATIC_BOOKING_NUDGE_AWAY_FROM_PRICE_DETAILS
 *  https://egtnl.prod.expedia.com/experiment/56914
 *  Returns true if Static Booking Nudge test is enabled
 * @returns {boolean}
 */
function isVrboStaticBookingNudgeOutsidePriceDetails() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('56914');
}

/**
 *  VRBO_CKO_Total_Savings
 *  https://egtnl.prod.expedia.com/experiment/56801
 *  Returns true if Price Details Total Savings test is enabled
 * @returns {boolean}
 */
function isVrboTotalSavingsEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('56801');
}

/**
 *  VRBO_Removal_of_Some_Billing_Fields
 *  https://egtnl.prod.expedia.com/experiment/55369
 *  Returns true if the A/B for removal some billing fields is enabled
 * @returns {boolean}
 */
function isRemovalOfSomeBillingFieldsEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55369');
}

/**
 *  VRBO_CKO_Improve_Error_Validation_Post_Book_Button
 *  https://egtnl.prod.expedia.com/experiment/55958
 *  Returns true if the A/B for improve error validation post book button is enabled
 * @returns {boolean}
 */
function isImproveErrorValidationPostBookButtonDesktop() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55958');
}

/**
 *  VRBO_CKO_Improve_Error_Validation_Post_Book_Button
 *  https://egtnl.prod.expedia.com/experiment/55948
 *  Returns true if the A/B for improve error validation post book button is enabled
 * @returns {boolean}
 */
function isImproveErrorValidationPostBookButtonMobile() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55948');
}
/**
 *  Vrbo_Inpath_PDP_Insurance_CSA_Kill_Switch
 *  https://egtnl.prod.expedia.com/experiment/55352
 *  Returns true if Kill Switch is enabled
 * @returns {boolean}
 */
function isVrboPDPInsuranceKillSwitchEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55352');
}

/**
 *  vrbo_personalized_final_step_booking_nudge
 *  https://egtnl.prod.expedia.com/experiment/55479
 *  Returns true if Static Booking Nudge test is enabled
 * @returns {boolean}
 */
function isVrboPersonalizedFinalStepBookingNudge() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55479');
}

/**
 *  InsurTech_VRBO_Benefit_Optimization_ADP
 *  https://egtnl.prod.expedia.com/experiment/55953
 *   Returns egtnl experiment object if InsurTech_VRBO_Benefit_Optimization_ADP is enabled
 * @returns {object}
 */
function isBenefitOptimizationADPEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperimentAndLog('55953')
    );
}

/**
 *  VRBO_Price_Details_Restructuring
 *  https://egtnl.prod.expedia.com/experiment/55662
 *  Renders another view of price details section if enabled
 * @returns {boolean}
 */
function isVrboPriceDetailsRestructuringEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('55662');
}

/**
 *  VRBO_Checkin_Checkout_Dates
 *  https://egtnl.prod.expedia.com/experiment/55904
 *  Returns egtnl experiment object if VRBO_Checkin_Checkout_Dates is enabled
 * @returns {object}
 */
function isVrboCheckinCheckoutDates() {
    return egtnlEvaluator.evaluateExperimentAndLog('55904');
}

/**
 *  Vrbo_CKO_Expiration_Date_Slash_Entry
 *  https://egtnl.prod.expedia.com/experiment/56585
 *  -- fill out --
 * @returns {boolean}
 */
function isExpirationDateSlashEntryEnabled() {
    return (
        (utility.isMobileViewport() || utility.isNativeMobileRequest()) &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('56585')
    );
}

/**
 *  https://egtnl.prod.expedia.com/experiment/56510
 *  Renders preloader message if enabled
 * @returns {boolean}
 */
function isVrboPreloaderExperience() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('56510');
}

/**
 *  Vrbo_CKO_Corrective_Feedback_client_side
 *  https://egtnl.prod.expedia.com/experiment/56507
 *  Returns true if A/B for corrective feedback is enabled
 * @returns {boolean}
 */
const isCorrectiveFeedbackEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('56507');

/**
 *  Returns true if the A/B for payment error banner error is enabled
 * @returns {boolean}
 */
const isPaymentValidationBannerEnabled = () => {
    const mwebAndNative =
        utility.isNativeMobileRequest() || utility.isMobileViewport();

    /**
     *  Vrbo_CKO_Web_Payment_Validation_Message_Banner
     *  https://egtnl.prod.expedia.com/experiment/56662
     */
    const isPaymentValidationBannerEnabledWeb =
        egtnlEvaluator.isEgtnlTestEnabledAndLog('56662');

    /**
     *  Vrbo_CKO_Mobile_Payment_Validation_Message_Banner
     * https://egtnl.prod.expedia.com/experiment/56663
     */
    const isPaymentValidationBannerEnabledMobile =
        egtnlEvaluator.isEgtnlTestEnabledAndLog('56663');

    return mwebAndNative
        ? isPaymentValidationBannerEnabledMobile
        : isPaymentValidationBannerEnabledWeb;
};

/**
 *  InsurTech_VRBO_2StepInterstitialFrDe
 *  https://egtnl.prod.expedia.com/experiment/53035
 *  Returns true if the A/B for Two step interstitial is enabled for FR and DE POS.
 *  When ipSniff (experiment 67994) is enabled, resolves the country from
 *  `appOptions.get('geoCountryCode')` (post-init) with a fallback to
 *  `config.geoCountryCode` (available at module load). Otherwise uses POS
 *  `appOptions.get('countryCode')`.
 * @returns {boolean}
 */
function isTwoStepInterstitialTestEnabledFrDe() {
    const geoCountryCode = isInsurtechVrboVasIpsniffEnabledNoLog()
        ? appOptions.get('geoCountryCode') ?? config.geoCountryCode ?? null
        : null;
    const countryCode = geoCountryCode || appOptions.get('countryCode');
    return (
        (countryCode === CONSTANTS.EXCLUDED_URGENCY_MSG_COUNTRIES.FR ||
            countryCode === CONSTANTS.EXCLUDED_URGENCY_MSG_COUNTRIES.DE) &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('53035')
    );
}

/**
 *  Insurtech_Vrbo_TP_Name_Change
 *  https://egtnl.prod.expedia.com/experiment/57600
 *  Returns true if the A/B for Insurtech_Vrbo_TP_Name_Change is enabled
 * @returns {boolean}
 */
function isVrboTpNameChangeEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('57600')
    );
}

/**
 *  Vrbo_CKO_Separate_Media_call
 *  https://egtnl.prod.expedia.com/experiment/57645
 *  Returns true if A/B for separate media call is enabled
 * @returns {boolean}
 */
const isSeparateMediaCallEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('57645');

/**
 *  One_Key_Credit_Card_Offer_Switch
 *  https://egtnl.prod.expedia.com/experiment/57549
 *  Returns true if the LTO offer is active (TnL 57549 is OFF)
 *  Returns false if the standard/BAU offer is active (TnL 57549 is ON)
 * @returns {boolean}
 */
const isOneKeyCreditCardOfferSwitchEnabled = () =>
    // ATTENTION: The logic for this TnL is reversed, that's why there is ! in the return statement
    !egtnlEvaluator.isEgtnlTestEnabledAndLog('57549');

/**
 *  Insurtech_VRBO_TripProtectionOnCheckout
 *  https://egtnl.prod.expedia.com/experiment/57125
 *  Returns egtnl experiment object if Insurtech_VRBO_TripProtectionOnCheckout is enabled
 * @returns {object}
 */
function isTripProtectionOnCheckoutEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperimentAndLog('57125')
    );
}

/**
 *  InsurTech_VRBO_HighlightValueOfTripInsurance
 *  https://egtnl.prod.expedia.com/experiment/58441
 *  Returns true if the A/B for InsurTech_VRBO_HighlightValueOfTripInsurance is enabled
 * @returns {boolean}
 */
function isTPOptimisationEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('58441')
    );
}

/**
 *  Insurtech_Vrbo_Font_Changes
 *  https://egtnl.prod.expedia.com/experiment/58900
 *  Returns true if the A/B for Insurtech_Vrbo_Font_Changes is enabled
 * @returns {boolean}
 */
function isVrboFontChangeEnabled() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('58900')
    );
}

/**
 *  Insurtech_Hybrid_Interstitial_UI_Optimization_Test
 *  https://egtnl.prod.expedia.com/experiment/65377
 *  Returns true if the A/B for MCKO_UI_Loading_Overlay is enabled
 * @returns {boolean}
 */
function isHybridInterstitialOptimizationEnabled() {
    return egtnlEvaluator.isEgtnlTestEnabledAndLog('65377');
}

/**
 *  Show_the_Math_Vrbo_Checkout
 *  https://egtnl.prod.expedia.com/experiment/58214
 *  Returns true if A/B for OKCC Show the Math is enabled
 * @returns {boolean}
 */
const isOneKeyCreditCardShowMathEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('58214');

/**
 *  Vrbo_CKO_OKCC_Session_Endpoint_Migration
 *  https://egtnl.prod.expedia.com/experiment/70749
 *  Returns true when session endpoint should use /v3
 * @returns {boolean}
 */
const isOneKeyCreditCardSessionV3UrlEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('70749');

/**
 *  Vrbo_CKO_OKCC_SdkEvent_Endpoint_Migration
 *  https://egtnl.prod.expedia.com/experiment/70751
 *  Returns true when sdkEvent endpoint should use /v3
 * @returns {boolean}
 */
const isOneKeyCreditCardSdkEventV3UrlEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('70751');

/**
 *  Vrbo_CKO_OKCC_Application_Endpoint_Migration
 *  https://egtnl.prod.expedia.com/experiment/70752
 *  Returns true when applications endpoint should use /v3
 * @returns {boolean}
 */
const isOneKeyCreditCardApplicationV3UrlEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('70752');

/**
 *  Vrbo_CKO_OKCC_Payment_Initialize_Endpoint_Migration
 *  https://egtnl.prod.expedia.com/experiment/70754
 *  Returns true when payment initialization endpoint should use /v3
 * @returns {boolean}
 */
const isOneKeyCreditCardPaymentInitializationV3UrlEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('70754');

/**

 Vrbo_legacy_cko_weatherPromise_position_mobile
 https://egtnl.prod.expedia.com/experiment/68504
 Returns 1 to show in first step and 2 last step for mobile

 Vrbo_legacy_cko_weatherPromise_position_web
 https://egtnl.prod.expedia.com/experiment/68505
 Returns 1 to show in first step and 2 last step for web

 @returns {boolean}
 */
const evaluateWeatherPromise = () => {
    const isNative = utility.isNativeMobileRequest() === true;

    const positionTnlMobile = '68504';
    const positionTnlWeb = '68505';

    const evaluate = (shouldLog, experimentNumber) =>
        shouldLog
            ? egtnlEvaluator.evaluateExperimentAndLog(experimentNumber).value
            : egtnlEvaluator.evaluateExperiment(experimentNumber).value;

    const evaluatedValue = evaluate(
        false,
        isNative ? positionTnlMobile : positionTnlWeb
    );

    return {
        isFirstStep: () => evaluatedValue === 1,
        isLastStep: () => evaluatedValue === 2,
    };
};

/**

 Weather_Promise_Feature_Gate
 https://egtnl.prod.expedia.com/experiment/57916
 Returns true if Feature Flag for Weather Promise is enabled
 @returns {boolean}
 */
const isWeatherPromiseFeatureGateEnabled = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('57916');

    return evaluatedData.value !== 0;
};

/**

 Weather_Promise_Feature_Gate
 https://egtnl.prod.expedia.com/experiment/67068
 Returns true if Feature Flag for Weather Promise New Analytics is enabled
 @returns {boolean}
 */
const isWeatherPromiseNewAnalyticsFeatureGateEnabled = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('67068');

    return evaluatedData.value !== 0;
};

/**
 Weather_Promise_Redesign
 https://egtnl.prod.expedia.com/experiment/65063
 Returns true if Feature Flag for new design Weather Promise is enabled
 @returns {boolean}
 */
const isWeatherPromiseNewDesignFeatureGateEnabled = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('65063');

    return evaluatedData.value !== 0;
};

/**
 * VRBO_CKO_LEGACY_MARKETING_CONSENT_API_SWITCH
 * https://egtnl.prod.expedia.com/experiment/58837
 * Returns true if the Vrbo Marketing Consent API is enabled
 * @returns {boolean}
 */
const isVrboMarketingConsentAPIEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('58837');

/**
 *  Vrbo_CKO_Tablet_Mobile_Smaller_Image_Size
 *  https://egtnl.prod.expedia.com/experiment/59588
 *  Returns true if Feature Flag for Tablet and Mobile smaller image size is enabled
 * @returns {boolean}
 */
const isTabletMobileSmallerSizeEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('59588') &&
    utility.isMobileOrTabletViewport();

/**
 *  Vrbo_CKO_FirstLastName_Validation
 *  https://egtnl.prod.expedia.com/experiment/59669
 *  Returns true if Feature Flag for First/Last Name validation is enabled
 * @returns {boolean}
 */
const isFirstLastNameValidationEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('59669');

/**
 *  VRBO_CKO_Ca_Cleaning_Tasks
 *  https://egtnl.prod.expedia.com/experiment/62348
 *  Returns true if Feature Flag for CA Cleaning Tasks is enabled
 * @returns {boolean}
 */
const isCaCleaningTasksEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('62348');

/**
 * Vrbo_Classic_Cko_DSA_Trader_Brn_Self_Certification
 * https://egtnl.prod.expedia.com/experiment/62756
 * Returns true if the Vrbo Classic Cko DSA Trader Brn Self Certification is enabled
 * @returns {boolean}
 */
const isVrboClassicCkoDsaTraderBrnSelfCertificationEnabled = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('62756');
    return evaluatedData.value === 1;
};

/**
 *  Insurtech_Vrbo_Pdp_Cof_Experiment
 *  https://egtnl.prod.expedia.com/experiment/62540
 *  Returns true if Insurtech_Vrbo_Pdp_Cof_Experiment is enabled
 * @returns {boolean}
 */
const isPdpCofEnabled = () => egtnlEvaluator.isEgtnlTestEnabledAndLog('62540');

/**
 * Vrbo_Cko_Night_Rate_Price_Redesign
 * https://egtnl.prod.expedia.com/experiment/64354
 * Returns true if Vrbo_Cko_Night_Rate_Price_Redesign is enabled
 */
const isCkoNightRatePriceRedesignEnabled = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('64354');
    return evaluatedData.value === 1;
};

/**
 * Vrbo_Cko_Price_Redesign_Tax_Tooltip
 * https://egtnl.prod.expedia.com/experiment/64912
 * Returns true if Vrbo_Cko_Price_Redesign_Tax_Tooltip is enabled
 */
const isVrboCkoPriceRedesignTaxTooltip = () => {
    const evaluatedData = egtnlEvaluator.evaluateExperiment('64912');
    return evaluatedData.value === 1;
};

/**
 *  Insurtech_Vrbo_Pdp_Content_Opt
 *  https://egtnl.prod.expedia.com/experiment/64614
 *  Returns true if the A/B for Insurtech_Vrbo_Pdp_Content_Opt is enabled
 * @returns {boolean}
 */
function isInsurtechVrboPdpContentOpt() {
    return (
        appOptions.get('countryCode') === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.isEgtnlTestEnabledAndLog('64614')
    );
}

/**
 *  Vrbo_PDP_with_RDD_vs_CoF
 *  https://egtnl.prod.expedia.com/experiment/64492
 *  Returns evaluation bucket value of the A/B for Vrbo_PDP_with_RDD_vs_CoF
 * @returns {integer}
 */
function evaluateVrboPdpWithRddVsCof() {
    return egtnlEvaluator.evaluateExperimentAndLog('64492').value;
}

/**
 *  OKCC_March_LTO_Offer_on_Classic_CKOs_enabler
 *  https://egtnl.prod.expedia.com/experiment/68470
 *  Returns true if the A/B for OKCC_March_LTO_Offer_on_Classic_CKOs_enabler is enabled
 * @returns {boolean}
 */
const isOneKeyCreditCardMarchLTOEnabler = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('68470');

/**
 *  OKCC_Vrbo_Classic_CKO_March_2026_LTO_offer_test
 *  https://egtnl.prod.expedia.com/experiment/68412
 *  Returns true if the A/B for OKCC_Vrbo_Classic_CKO_March_2026_LTO_offer_test is enabled
 * @returns {boolean}
 */
const isOneKeyCreditCardMarchLTOOfferTest = () => {
    if (isOneKeyCreditCardMarchLTOEnabler()) {
        return egtnlEvaluator.evaluateExperimentAndLog('68412').value;
    }
    return false;
};

/**
 *  Vrbo_CKO_3DS_V2_Upgrade
 *  https://egtnl.prod.expedia.com/experiment/67357
 *  Toggle for pay-3ds-js-libs 2.0.1 upgrade
 *  Returns true if the upgraded 3DS connector (v2.0.1) should be used
 * @returns {boolean}
 */
const is3DSV2UpgradeEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('67357');

/**
 *  Insurtech_Vrbo_ADP_TI_RightCTA
 *  https://egtnl.prod.expedia.com/experiment/66073
 *  Returns true if the A/B for Insurtech_Vrbo_ADP_TI_RightCTA is enabled
 * @returns {boolean}
 */
const isInsurtechVrboADPTIRightCTA = (geoCountryCode, isCSAProduct) => {
    const countryCode = geoCountryCode || appOptions.get('countryCode');
    return (
        countryCode === CONSTANTS.COUNTRY_CODES.US &&
        isCSAProduct &&
        egtnlEvaluator.evaluateExperiment('66073')?.value === 1
    );
};

/**
 *  Insurtech_Vrbo_TI_RightCTA_V2
 *  https://egtnl.prod.expedia.com/experiment/68522
 *  Returns true if the A/B for Insurtech_Vrbo_TI_RightCTA_V2 is enabled
 * @returns {boolean}
 */
const isInsurtechVrboTIRightCTAV2 = (geoCountryCode, isCSAProduct) => {
    const countryCode = geoCountryCode || appOptions.get('countryCode');
    return (
        countryCode === CONSTANTS.COUNTRY_CODES.US &&
        isCSAProduct &&
        egtnlEvaluator.evaluateExperiment('68522')?.value === 1
    );
};

/**
 *  OKCC_Vrbo_Classic_CKO_Feb_BAU_offer_test
 *  https://egtnl.prod.expedia.com/experiment/67503
/**
 *  VRBO_CKO_One_Key_Small_amount_switch_off
 *  https://egtnl.prod.expedia.com/experiment/68475
 *  Returns true if the VRBO_CKO_One_Key_Small_amount_switch_off is enabled
 * @returns {boolean}
 */
const isVrboCkoOneKeySmallAmountSwitchOff = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('68475');

/**
 *  VRBO_Cancel_Policies_Time_Change
 *  https://egtnl.prod.expedia.com/experiment/69652
 *  Returns true if the VRBO_Cancel_Policies_Time_Change is enabled
 * @returns {boolean}
 */
const isVrboCancelPoliciesTimeChangeEnabled = () =>
    egtnlEvaluator.isEgtnlTestEnabledAndLog('69652');

/**
 *  Insurtech_Vrbo_PerNight_Pricing_Test
 *  https://egtnl.prod.expedia.com/experiment/69554
 *  Returns true if the A/B for Insurtech_Vrbo_PerNight_Pricing_Test is enabled
 * @returns {boolean}
 */
const isInsurtechVrboPerNightPricing = (geoCountryCode) => {
    const countryCode = geoCountryCode || appOptions.get('countryCode');
    return (
        countryCode === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperiment('69554')?.value === 1
    );
};

/**
 *  Insurtech_Vrbo_ADP_optimisation_follow_up
 *  https://egtnl.prod.expedia.com/experiment/70609
 *  Returns true if the A/B for Insurtech_Vrbo_ADP_optimisation_follow_up is enabled
 * @returns {boolean}
 */
const isInsurtechVrboADPOptimisationFollowUp = (geoCountryCode) => {
    const countryCode = geoCountryCode || appOptions.get('countryCode');
    return (
        countryCode === CONSTANTS.COUNTRY_CODES.US &&
        egtnlEvaluator.evaluateExperiment('70609')?.value === 1
    );
};

export default {
    isFeeMessagingMultipayEnabled,
    isOptimizeBwCModule,
    isOptimisePaymentProtectionModuleDesktopTablet,
    isOptimisePaymentProtectionModuleMwebNative,
    isBwcTopMessageDisabledDesktop,
    isOneKeyCreditCardEnabled,
    isOneKeyCreditCardOfferSwitchEnabled,
    isOneKeyCreditCardShowMathEnabled,
    isOneKeyCreditCardSessionV3UrlEnabled,
    isOneKeyCreditCardSdkEventV3UrlEnabled,
    isOneKeyCreditCardApplicationV3UrlEnabled,
    isOneKeyCreditCardPaymentInitializationV3UrlEnabled,
    updateOneKeyIconColors,
    isTwoPageCheckoutEnabled,
    isVrboTagCommanderIntegration,
    isHygieneFixTestEnabled,
    isTPAssistanceEnabled,
    isADPAssistanceEnabled,
    isCKOPrimingEnabled,
    isCovidVerbiageInStepTwoRemoved,
    isPropertyRatingChangeEnabled,
    isADPBenefitOptimizationEnabled,
    displayGenericPaymentError,
    isCurrencyDisclosureBoxUpdatedMobile,
    isCurrencyDisclosureBoxUpdatedWeb,
    isMandatoryRequiredFieldsInfoEnabledMobile,
    isTierSpecificOneKeyBanner,
    isFeedbackForTextFields,
    isTwoStepInterstitialTestEnabledMobile,
    isTwoPageCheckoutDesktopTabletWebV2Enabled,
    isTwoPageCheckoutMobileV2Enabled,
    isTPPrimingEnabled,
    isVrboStaticBookingNudge,
    updateInsurTechTouchpointsColorsEnabled,
    isVrboPDPInsuranceKillSwitchEnabled,
    isVrboPersonalizedFinalStepBookingNudge,
    isRemovalOfSomeBillingFieldsEnabled,
    isBenefitOptimizationADPEnabled,
    isImproveErrorValidationPostBookButtonDesktop,
    isImproveErrorValidationPostBookButtonMobile,
    isPaymentErrorBannerRedesignEnabledWeb,
    isPaymentErrorBannerRedesignEnabledMobile,
    isVrboPriceDetailsRestructuringEnabled,
    isVrboCheckinCheckoutDates,
    isExpirationDateSlashEntryEnabled,
    isVrboPreloaderExperience,
    isCorrectiveFeedbackEnabled,
    isPaymentValidationBannerEnabled,
    isVrboTotalSavingsEnabled,
    isTwoStepInterstitialTestEnabledFrDe,
    isVrboStaticBookingNudgeOutsidePriceDetails,
    isVrboTpNameChangeEnabled,
    isSeparateMediaCallEnabled,
    isTripProtectionOnCheckoutEnabled,
    isTPOptimisationEnabled,
    isPrimingOnTwoPageCheckout,
    isVrboFontChangeEnabled,
    isFirstLastNameValidationEnabled,
    evaluateWeatherPromise,
    isWeatherPromiseFeatureGateEnabled,
    isWeatherPromiseNewDesignFeatureGateEnabled,
    isWeatherPromiseNewAnalyticsFeatureGateEnabled,
    isTabletMobileSmallerSizeEnabled,
    isVrboMarketingConsentAPIEnabled,
    isCaCleaningTasksEnabled,
    isVrboClassicCkoDsaTraderBrnSelfCertificationEnabled,
    isPdpCofEnabled,
    isInsurTechVrboConvergenceEnabled,
    isCkoNightRatePriceRedesignEnabled,
    isVrboCkoPriceRedesignTaxTooltip,
    isInsurtechVrboPdpContentOpt,
    isHybridInterstitialOptimizationEnabled,
    evaluateVrboPdpWithRddVsCof,
    is3DSV2UpgradeEnabled,
    isInsurTechVrboCAConvergenceEnabled,
    isInsurtechVrboADPTIRightCTA,
    isInsurtechVrboVasIpsniffEnabled,
    isInsurtechVrboVasIpsniffEnabledNoLog,
    isVrboCkoOneKeySmallAmountSwitchOff,
    isOneKeyCreditCardMarchLTOEnabler,
    isOneKeyCreditCardMarchLTOOfferTest,
    isInsurtechVrboTIRightCTAV2,
    isVrboCancelPoliciesTimeChangeEnabled,
    isInsurtechVrboPerNightPricing,
    isInsurtechVrboADPOptimisationFollowUp,
};
